import { Subscription } from '../../../../types/subscription';
import { Bot } from 'grts-utils/src/types/Bot';
import { useCalculateCurrentSingleProfitCalculationQuery } from '../../../../store/services/api';
import SingleProfitCalculationResult from '../../../ProfitCalculations/Content/SingleProfitCalculation/Result';
import LoadingIcons from 'react-loading-icons';

interface Props {
  subscription: Subscription;
  bot: Bot | undefined;
}

const Calculations = (props: Props) => {
  const { subscription } = props;

  const { data: spcResult, isLoading } =
    useCalculateCurrentSingleProfitCalculationQuery(subscription.baseAsset);

  if (isLoading) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadingIcons.Grid width={60} />
      </div>
    );
  }

  return (
    <div
      style={{
        flex: 1,
      }}
    >
      <SingleProfitCalculationResult data={spcResult?.data} />
    </div>
  );
};

export default Calculations;
